import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'
import CertificatesCreate from './Certificates.create'
import CertificatesEdit from './Certificates.edit'
import CertificatesList from './Certificates.list'
import CertificatesShow from './Certificates.show'

const resource = {
  list: CertificatesList,
  edit: CertificatesEdit,
  show: CertificatesShow,
  create: CertificatesCreate,
  icon: WorkspacePremiumIcon,
}

export default resource
